(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/upcoming-events/assets/javascripts/game-type-filter.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/upcoming-events/assets/javascripts/game-type-filter.js');
"use strict";


const _svs$ui$ReactDropdown = svs.ui.ReactDropdown,
  DropdownSelectItem = _svs$ui$ReactDropdown.DropdownSelectItem,
  DropdownItem = _svs$ui$ReactDropdown.DropdownItem,
  DropdownLabel = _svs$ui$ReactDropdown.DropdownLabel;
const GameTypes = svs.poker_react.components.common.constants.GameTypes;
const GameTypeFilter = _ref => {
  let setActiveGameTypeFilter = _ref.setActiveGameTypeFilter,
    activeGameTypeFilter = _ref.activeGameTypeFilter;
  return React.createElement("div", {
    className: "poker-filter-dropdown"
  }, React.createElement(DropdownSelectItem, {
    branding: "poker-react",
    onSelect: selected => setActiveGameTypeFilter(selected),
    selectLabel: "Speltyp",
    v2: true
  }, GameTypes.map(gameType => React.createElement(DropdownItem, {
    key: gameType.id,
    name: gameType.id,
    selected: activeGameTypeFilter === gameType.id
  }, React.createElement(DropdownLabel, null, gameType.title)))));
};
setGlobal('svs.poker_react.components.upcomingEvents.GameTypeFilter', GameTypeFilter);

 })(window);